import { gql } from '@apollo/client';

const assetFields = gql`
  fragment AssetField on Asset {
    id
    tokenId
    tokenAddress
    totalSupply
    type
    numOwners
    uri
    image
    animation_url
    title
    description
    nativePrice
    mogulPrice
    creator {
      address
    }
    lastSoldPrice {
      price
      tokenAddress
      #symbol
    }
    commission {
      id
      commissionBasisPoint
    }
    owners {
      id
      quantity
      account {
        address
      }
    }
    # will always keep track of both eth and stars on mainnet price so this is okay
    #activeListings(orderBy: "starsPrice", orderDirection: "asc") {
    #  id
    #}
  }
`;

export default assetFields;
